import React from 'react';
import { Layout, Row } from 'antd';
import { Link } from 'react-router-dom';
import './Landing.css';
import { ViaLogo, LogoLocations } from '../../components/logo/ViaLogo';


/**
 * A temporay landing page.
 * We should be redirecting the user to the landing page made commercially.
 */
function Landing() {
  return (
    <Layout className="landing-page">
      <Row type="flex" justify="center">
        <ViaLogo logoSrc={LogoLocations.REVERSED_WHITE_CIRCLE_BLUE_M} className="landing-logo" />
      </Row>
      <Row type="flex" justify="center">
        <Link
          className="landing-link"
          to="/dashboard"
          style={{ color: 'white' }}
        >
            Configure your Inspections
        </Link>
      </Row>
    </Layout>
  );
}

export default Landing;
